import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
`;

export const ContainerHeader = styled.div``;

export const ContainerContent = styled.div`
	position: absolute;
	background-color: ${tokens.color_gray_light};
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
`;

export const ContainerSelect = styled.div``;
